import React, { useState, useEffect } from 'react';
import api from '../api';

var DAY_NAMES = ['\u05e8\u05d0\u05e9\u05d5\u05df', '\u05e9\u05e0\u05d9', '\u05e9\u05dc\u05d9\u05e9\u05d9', '\u05e8\u05d1\u05d9\u05e2\u05d9', '\u05d7\u05de\u05d9\u05e9\u05d9', '\u05e9\u05d9\u05e9\u05d9', '\u05e9\u05d1\u05ea'];
var DAY_NAMES_SHORT = ['\u05d0\u05f3', '\u05d1\u05f3', '\u05d2\u05f3', '\u05d3\u05f3', '\u05d4\u05f3', '\u05d5\u05f3', '\u05e9\u05f3'];

export default function RankScheduleSettings() {
  var _s = useState(null), data = _s[0], setData = _s[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _sv = useState(false), saving = _sv[0], setSaving = _sv[1];
  var _sd = useState([]), selectedDays = _sd[0], setSelectedDays = _sd[1];
  var _m = useState(null), message = _m[0], setMessage = _m[1];
  var _es = useState(null), editingSite = _es[0], setEditingSite = _es[1];
  var _sm = useState('inherit'), siteMode = _sm[0], setSiteMode = _sm[1];
  var _sdy = useState([]), siteDays = _sdy[0], setSiteDays = _sdy[1];
  var _ss = useState(false), siteSaving = _ss[0], setSiteSaving = _ss[1];
  var _dp = useState(30), depth = _dp[0], setDepth = _dp[1];
  var _dps = useState(false), depthSaving = _dps[0], setDepthSaving = _dps[1];

  useEffect(function() { loadData(); }, []);

  function loadData() {
    api.getRankSchedule().then(function(d) {
      setData(d);
      setSelectedDays(d.system_days || [0, 3]);
      setLoading(false);
    }).catch(function(e) { console.error(e); setLoading(false); });
    api.getRankDepth().then(function(d) { setDepth(d.depth || 30); }).catch(function(e) { console.error(e); });
  }

  function handleSaveDepth(d) {
    setDepthSaving(true);
    api.updateRankDepth(d).then(function() {
      setDepth(d);
      setMessage({ type: 'success', text: 'עומק הבדיקה עודכן' });
      setDepthSaving(false);
      setTimeout(function() { setMessage(null); }, 3000);
    }).catch(function(e) {
      setMessage({ type: 'error', text: 'שגיאה: ' + e.message });
      setDepthSaving(false);
      setTimeout(function() { setMessage(null); }, 3000);
    });
  }

  function handleSave() {
    setSaving(true);
    api.updateRankSchedule(selectedDays).then(function(result) {
      setData(function(prev) { return Object.assign({}, prev, { system_days: selectedDays, estimated_monthly_cost: result.estimated_monthly_cost }); });
      setMessage({ type: 'success', text: '\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05e0\u05e9\u05de\u05e8\u05d5' });
      setSaving(false);
      setTimeout(function() { setMessage(null); }, 3000);
    }).catch(function(e) {
      setMessage({ type: 'error', text: '\u05e9\u05d2\u05d9\u05d0\u05d4: ' + e.message });
      setSaving(false);
      setTimeout(function() { setMessage(null); }, 3000);
    });
  }

  function toggleDay(day) {
    setSelectedDays(function(prev) {
      return prev.indexOf(day) >= 0 ? prev.filter(function(d) { return d !== day; }) : prev.concat([day]).sort();
    });
  }

  function startEditSite(site) {
    setEditingSite(site.id);
    if (site.rank_check_days === null || site.rank_check_days === undefined) {
      setSiteMode('inherit'); setSiteDays([]);
    } else if (Array.isArray(site.rank_check_days) && site.rank_check_days.length === 0) {
      setSiteMode('disabled'); setSiteDays([]);
    } else {
      setSiteMode('custom'); setSiteDays(site.rank_check_days || []);
    }
  }

  function saveSiteSchedule(siteId) {
    setSiteSaving(true);
    var days = siteMode === 'custom' ? siteDays : null;
    api.updateSiteRankSchedule(siteId, siteMode, days).then(function() {
      loadData(); setEditingSite(null);
      setMessage({ type: 'success', text: '\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05d4\u05d0\u05ea\u05e8 \u05e0\u05e9\u05de\u05e8\u05d5' });
      setSiteSaving(false);
      setTimeout(function() { setMessage(null); }, 3000);
    }).catch(function(e) {
      setMessage({ type: 'error', text: '\u05e9\u05d2\u05d9\u05d0\u05d4: ' + e.message }); setSiteSaving(false);
      setTimeout(function() { setMessage(null); }, 3000);
    });
  }

  function toggleSiteDay(day) {
    setSiteDays(function(prev) {
      return prev.indexOf(day) >= 0 ? prev.filter(function(d) { return d !== day; }) : prev.concat([day]).sort();
    });
  }

  function getSiteDisplayDays(site) {
    if (site.rank_check_days === null || site.rank_check_days === undefined)
      return { label: '\u05d1\u05e8\u05d9\u05e8\u05ea \u05de\u05d7\u05d3\u05dc', days: selectedDays, color: 'var(--text-muted)' };
    if (Array.isArray(site.rank_check_days) && site.rank_check_days.length === 0)
      return { label: '\u05de\u05d5\u05e9\u05d1\u05ea', days: [], color: 'var(--red)' };
    return { label: '\u05de\u05d5\u05ea\u05d0\u05dd', days: site.rank_check_days, color: 'var(--accent)' };
  }

  function perTaskCost(d) {
    // Standard Queue: $0.0006 base (1 page) + $0.00045 per extra page of 10.
    var pages = Math.ceil((d || 30) / 10);
    return 0.0006 + (pages - 1) * 0.00045;
  }

  function estimateCost(daysCount, keywords) {
    var monthlyTasks = keywords * 2 * daysCount * 4.33;
    var firstOfMonth = keywords * 2;
    return ((monthlyTasks + firstOfMonth) * perTaskCost(depth)).toFixed(2);
  }

  if (loading) return React.createElement('div', { style: { padding: '20px', color: 'var(--text-muted)', fontSize: '13px' } }, '\u05d8\u05d5\u05e2\u05df \u05d4\u05d2\u05d3\u05e8\u05d5\u05ea...');
  if (!data) return null;

  var hasChanges = JSON.stringify(selectedDays) !== JSON.stringify(data.system_days);
  var modeLabels = { inherit: '\u05d1\u05e8\u05d9\u05e8\u05ea \u05de\u05d7\u05d3\u05dc', custom: '\u05d9\u05de\u05d9\u05dd \u05de\u05d5\u05ea\u05d0\u05de\u05d9\u05dd', disabled: '\u05de\u05d5\u05e9\u05d1\u05ea' };

  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '16px' } },
    React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
      React.createElement('div', null,
        React.createElement('div', { style: { fontSize: '15px', fontWeight: 700 } }, '\u05ea\u05d3\u05d9\u05e8\u05d5\u05ea \u05d1\u05d3\u05d9\u05e7\u05ea \u05de\u05d9\u05e7\u05d5\u05de\u05d9\u05dd'),
        React.createElement('div', { style: { fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' } }, '\u05d1\u05d7\u05e8 \u05d1\u05d0\u05d9\u05dc\u05d5 \u05d9\u05de\u05d9\u05dd \u05ea\u05ea\u05d1\u05e6\u05e2 \u05d1\u05d3\u05d9\u05e7\u05ea \u05de\u05d9\u05e7\u05d5\u05de\u05d9\u05dd \u05d0\u05d5\u05d8\u05d5\u05de\u05d8\u05d9\u05ea')
      ),
      hasChanges ? React.createElement('button', {
        onClick: handleSave, disabled: saving,
        style: { padding: '6px 16px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 600, cursor: saving ? 'wait' : 'pointer', opacity: saving ? 0.6 : 1, fontFamily: 'var(--sans)' }
      }, saving ? '\u05e9\u05d5\u05de\u05e8...' : '\u05e9\u05de\u05d5\u05e8 \u05e9\u05d9\u05e0\u05d5\u05d9\u05d9\u05dd') : null
    ),
    message ? React.createElement('div', {
      style: { padding: '8px 14px', borderRadius: '6px', fontSize: '12px', background: message.type === 'success' ? 'var(--green-glow)' : 'var(--red-glow)', color: message.type === 'success' ? 'var(--green)' : 'var(--red)', border: '1px solid ' + (message.type === 'success' ? 'var(--green)' : 'var(--red)') }
    }, message.text) : null,
    React.createElement('div', { style: { display: 'flex', gap: '6px', flexWrap: 'wrap' } },
      DAY_NAMES.map(function(name, i) {
        var isSelected = selectedDays.indexOf(i) >= 0;
        return React.createElement('button', { key: i, onClick: function() { toggleDay(i); },
          style: { padding: '8px 14px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s', fontFamily: 'var(--sans)', background: isSelected ? 'var(--accent)' : 'var(--surface)', color: isSelected ? '#fff' : 'var(--text-secondary)', border: isSelected ? '2px solid var(--accent)' : '2px solid var(--border)' }
        }, name);
      })
    ),
    React.createElement('div', {
      style: { display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '12px', color: 'var(--text-muted)', padding: '8px 12px', background: 'var(--bg)', borderRadius: '6px', border: '1px solid var(--border)' }
    },
      React.createElement('span', null, '\uD83D\uDCC5 ' + selectedDays.length + ' \u05d9\u05de\u05d9\u05dd \u05d1\u05e9\u05d1\u05d5\u05e2'),
      React.createElement('span', null, '\uD83D\uDD11 ' + data.total_keywords + ' \u05d1\u05d9\u05d8\u05d5\u05d9\u05d9\u05dd'),
      React.createElement('span', null, '\uD83D\uDCB0 ~$' + estimateCost(selectedDays.length, data.total_keywords) + '/\u05d7\u05d5\u05d3\u05e9'),
      React.createElement('span', { style: { color: 'var(--green)' } }, '\u2713 \u05d1-1 \u05d1\u05db\u05dc \u05d7\u05d5\u05d3\u05e9: \u05d1\u05d3\u05d9\u05e7\u05d4 \u05de\u05dc\u05d0\u05d4 \u05ea\u05de\u05d9\u05d3')
    ),
    React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', padding: '8px 12px', background: 'var(--bg)', borderRadius: '6px', border: '1px solid var(--border)' } },
      React.createElement('span', { style: { fontSize: '12px', fontWeight: 600 } }, '\u05e2\u05d5\u05de\u05e7 \u05d1\u05d3\u05d9\u05e7\u05d4 (\u05de\u05d9\u05e7\u05d5\u05de\u05d9\u05dd \u05e0\u05e2\u05e7\u05d1\u05d9\u05dd)'),
      [10, 20, 30].map(function(d) {
        var isSel = depth === d;
        return React.createElement('button', { key: d, onClick: function() { if (!depthSaving && !isSel) handleSaveDepth(d); }, disabled: depthSaving,
          style: { padding: '5px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: 600, cursor: depthSaving ? 'wait' : 'pointer', fontFamily: 'var(--sans)', background: isSel ? 'var(--accent)' : 'var(--surface)', color: isSel ? '#fff' : 'var(--text-secondary)', border: isSel ? '2px solid var(--accent)' : '2px solid var(--border)' }
        }, '1-' + d);
      }),
      React.createElement('span', { style: { fontSize: '11px', color: 'var(--text-muted)' } }, '\u05e0\u05de\u05d5\u05da \u05d9\u05d5\u05ea\u05e8 = \u05d6\u05d5\u05dc \u05d9\u05d5\u05ea\u05e8, \u05d0\u05da \u05e2\u05d5\u05e7\u05d1 \u05e4\u05d7\u05d5\u05ea \u05de\u05d9\u05e7\u05d5\u05de\u05d9\u05dd')
    ),
    React.createElement('div', { style: { marginTop: '8px' } },
      React.createElement('div', { style: { fontSize: '13px', fontWeight: 600, marginBottom: '8px' } }, '\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05dc\u05e4\u05d9 \u05d0\u05ea\u05e8'),
      React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '4px' } },
        data.sites.map(function(site) {
          var display = getSiteDisplayDays(site);
          var isEditing = editingSite === site.id;
          return React.createElement('div', { key: site.id, style: { padding: '8px 12px', borderRadius: '6px', background: isEditing ? 'var(--bg)' : 'transparent', border: isEditing ? '1px solid var(--border)' : '1px solid transparent' } },
            React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' } },
              React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: '8px', flex: 1 } },
                React.createElement('span', { style: { fontSize: '13px', fontWeight: 500 } }, site.name),
                React.createElement('span', { style: { fontSize: '10px', padding: '2px 8px', borderRadius: '10px', background: display.color === 'var(--red)' ? 'var(--red-glow)' : display.color === 'var(--accent)' ? 'var(--accent-soft)' : 'var(--surface)', color: display.color, fontWeight: 600 } }, display.label),
                display.days.length > 0 ? React.createElement('span', { style: { fontSize: '11px', color: 'var(--text-muted)', fontFamily: 'var(--mono)' } }, display.days.map(function(d) { return DAY_NAMES_SHORT[d]; }).join(', ')) : null
              ),
              React.createElement('button', { onClick: function() { isEditing ? setEditingSite(null) : startEditSite(site); },
                style: { padding: '3px 10px', fontSize: '11px', cursor: 'pointer', background: 'var(--surface-hover)', border: '1px solid var(--border)', borderRadius: '4px', color: 'var(--text-secondary)', fontFamily: 'var(--sans)' }
              }, isEditing ? '\u05d1\u05d9\u05d8\u05d5\u05dc' : '\u05e2\u05e8\u05d5\u05da')
            ),
            isEditing ? React.createElement('div', { style: { marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' } },
              React.createElement('div', { style: { display: 'flex', gap: '6px' } },
                ['inherit', 'custom', 'disabled'].map(function(m) {
                  return React.createElement('button', { key: m, onClick: function() { setSiteMode(m); },
                    style: { padding: '5px 12px', fontSize: '12px', cursor: 'pointer', borderRadius: '6px', fontFamily: 'var(--sans)', fontWeight: 500, background: siteMode === m ? 'var(--accent)' : 'var(--surface)', color: siteMode === m ? '#fff' : 'var(--text-secondary)', border: siteMode === m ? '1px solid var(--accent)' : '1px solid var(--border)' }
                  }, modeLabels[m]);
                })
              ),
              siteMode === 'custom' ? React.createElement('div', { style: { display: 'flex', gap: '4px' } },
                DAY_NAMES.map(function(name, i) {
                  var isSelected = siteDays.indexOf(i) >= 0;
                  return React.createElement('button', { key: i, onClick: function() { toggleSiteDay(i); },
                    style: { padding: '5px 10px', fontSize: '12px', borderRadius: '6px', cursor: 'pointer', fontFamily: 'var(--sans)', background: isSelected ? 'var(--accent)' : 'var(--surface)', color: isSelected ? '#fff' : 'var(--text-muted)', border: isSelected ? '1px solid var(--accent)' : '1px solid var(--border)' }
                  }, DAY_NAMES_SHORT[i]);
                })
              ) : null,
              React.createElement('div', { style: { display: 'flex', gap: '6px' } },
                React.createElement('button', { onClick: function() { saveSiteSchedule(site.id); }, disabled: siteSaving,
                  style: { padding: '5px 14px', background: 'var(--green)', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '12px', cursor: siteSaving ? 'wait' : 'pointer', fontFamily: 'var(--sans)', fontWeight: 600 }
                }, siteSaving ? '\u05e9\u05d5\u05de\u05e8...' : '\u05e9\u05de\u05d5\u05e8')
              )
            ) : null
          );
        })
      )
    )
  );
}
